/**
 * Custom logger utility that disables console logs in production
 * To use: import { logger } from 'utils/logger';
 * Then use: logger.log("), logger.warn(), logger.error() etc.
 */

const isProduction = process.env.NODE_ENV === 'production';

// Create a logger object with methods that correspond to console methods
export const logger = Object.keys(console)
  .reduce((acc, method) => {
    // For most methods, we disable them in production
    if (['log', 'debug', 'info', 'trace'].includes(method)) {
      acc[method] = isProduction
        ? () => {}  // No-op in production
        : (...args) => console[method](...args);
    } else {
      // Always keep error, warn, etc. even in production
      acc[method] = (...args) => console[method](...args);
    }
    return acc;
  }, {});

// Optional: Add a special method for logs that should always appear, even in production
logger.always = (...args) => console.log(...args); 